import { injectable } from 'inversify';
import 'reflect-metadata';
import { LookupValues } from '../_api/models/lookup-values.model';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import { ApiResponse } from '../utils/api-response.utils';

@injectable()
export class LookupService {
  async getLookupValues(): Promise<ApiResponse<LookupValues>> {
    try {
      const response =
        await axiosClient.get<ApiResponse<LookupValues>>('/api/lookup/values');

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getCountryAndChannel(): Promise<ApiResponse<LookupValues>> {
    try {
      const response = await axiosClient.get<ApiResponse<LookupValues>>(
        '/api/lookup/country-and-channel'
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
